import { render } from "./CourtAttendanceReport.vue?vue&type=template&id=37e97e45&ts=true"
import script from "./CourtAttendanceReport.vue?vue&type=script&lang=ts"
export * from "./CourtAttendanceReport.vue?vue&type=script&lang=ts"

import "./CourtAttendanceReport.vue?vue&type=style&index=0&id=37e97e45&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__